<template>
  <textarea
    :value="value"
    :class="['bg-gray-50 rounded-lg border', $attrs.class] | twMerge"
    @input="onChange"
    v-bind="inputAttrs"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    inputAttrs() {
      // eslint-disable-next-line no-unused-vars
      const { class: _class, ...attrs } = this.$attrs
      return attrs
    },
    inputListeners() {
      // eslint-disable-next-line no-unused-vars
      const { input: _input, ...listeners } = this.$listeners
      return listeners
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
